
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";

interface DeleteConfirmDrawerProps {
  onCancel: () => void;
  onConfirm: () => void;
  name?: string;
  title?: string;
  description?: string;
}

export default function DeleteConfirmDrawer({ 
  onCancel, 
  onConfirm,
  name = "este item",
  title = "Confirmar exclusão",
  description
}: DeleteConfirmDrawerProps) {
  return (
    <DrawerContent>
      <DrawerHeader>
        <div className="flex items-center gap-2 text-destructive">
          <AlertTriangle className="h-5 w-5" />
          <DrawerTitle>{title}</DrawerTitle>
        </div>
        <DrawerDescription>
          {description || `Tem certeza que deseja excluir ${name}? Esta ação não pode ser desfeita.`}
        </DrawerDescription>
      </DrawerHeader>
      <DrawerFooter>
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="destructive" onClick={onConfirm}>
          Excluir
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}
